<template>
  <v-app id="app">
    <v-app-bar
      :height="$vuetify.breakpoint.smAndDown ? 75 : $vuetify.breakpoint.lgAndUp ? 205 : 140"
      app
      class="main-app-bar"
      color="white"
      fixed
      hide-on-scroll
      elevation="0"
      light
    >
      <v-container class="pa-0">
        <v-row :class="$vuetify.breakpoint.xsOnly && 'flex-column'" align="center" no-gutters>
          <img
            v-if="$themeColor === 'paivakoti'"
            :alt="$t('form.title')"
            :style="{ height: $vuetify.breakpoint.smAndDown ? '50px' : $vuetify.breakpoint.lgAndUp ? '130px' : '70px' }"
            src="../assets/img/skib-bss-daghemmet.svg"
            style="height: auto; margin: auto"
          />
          <img
            v-else-if="$themeColor === 'koulu'"
            :alt="$t('form.title')"
            :style="{ height: $vuetify.breakpoint.smAndDown ? '50px' : $vuetify.breakpoint.lgAndUp ? '130px' : '70px' }"
            src="../assets/img/skib-bss.svg"
            style="height: auto; margin: auto"
          />
          <img
            v-else-if="$themeColor === 'kulttuuri'"
            :alt="$t('form.title')"
            :style="{ height: $vuetify.breakpoint.smAndDown ? '50px' : $vuetify.breakpoint.lgAndUp ? '130px' : '70px' }"
            src="../assets/img/skib-kultur.svg"
            style="height: auto; margin: auto"
          />
          <img
            v-else
            :alt="$t('form.title')"
            :style="{ height: $vuetify.breakpoint.smAndDown ? '50px' : $vuetify.breakpoint.lgAndUp ? '130px' : '70px' }"
            src="../assets/img/logo.svg"
            style="height: auto; margin: auto"
          />
          <v-spacer></v-spacer>
          <template v-if="$vuetify.breakpoint.smAndUp">
            <v-btn
              :class="language === 'fi' && 'selected-language'"
              class="font-weight-regular py-4 py-md-8"
              :color="$themeColor"
              small
              text
              tile
              @click="setLanguage('fi')"
            >
              Suomeksi
            </v-btn>
            <v-btn
              :class="language === 'sv' && 'selected-language'"
              class="font-weight-regular py-4 py-md-8"
              :color="$themeColor"
              small
              text
              tile
              @click="setLanguage('sv')"
            >
              På Svenska
            </v-btn>
          </template>

          <template v-if="!!$slots.buttons && $vuetify.breakpoint.mdAndUp">
            <v-divider class="grey lighten-1 my-7" vertical></v-divider>
            <slot name="buttons"></slot>
          </template>
        </v-row>
      </v-container>

      <template v-if="$vuetify.breakpoint.xsOnly" v-slot:extension>
        <div class="text-center" style="width: 100%">
          <v-btn
            :class="language === 'fi' && 'selected-language'"
            class="font-weight-regular py-4 py-md-8"
            :color="$themeColor"
            small
            text
            tile
            @click="setLanguage('fi')"
          >
            Suomeksi
          </v-btn>
          <v-btn
            :class="language === 'sv' && 'selected-language'"
            class="font-weight-regular py-4 py-md-8"
            :color="$themeColor"
            small
            text
            tile
            @click="setLanguage('sv')"
          >
            På Svenska
          </v-btn>
        </div>
      </template>
    </v-app-bar>
    <v-main :class="$themeColor !== 'primary' ? $themeColor + 'light' : 'secondary'">
      <notification-snackbar></notification-snackbar>
      <slot></slot>
    </v-main>

    <template v-if="!!$slots.buttons && $vuetify.breakpoint.smAndDown">
      <v-bottom-navigation app class="white" horizontal>
        <slot name="buttons"></slot>
      </v-bottom-navigation>
    </template>
  </v-app>
</template>

<script>
import NotificationSnackbar from "@/components/NotificationSnackbar";

export default {
  name: 'FormLayout',
  components: {NotificationSnackbar},
  props: ['language'],
  data() {
    return {
      // language: 'fi',
    };
  },
  methods: {
    setLanguage(lang) {
      this.$emit('language-changed', lang);
    },
  },
};
</script>

<style lang="scss" scoped>
.selected-language {
  &:after {
    content: '';
    height: 3px;
    width: 100%;
    position: absolute;
    bottom: 0;
    background: #000;
  }
}

</style>
